import React from "react";
import { Route, Routes } from "react-router-dom";
import { EmailLogDetails, EmailLogList } from "./containers";

export const EmailLogRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EmailLogList />} />
      <Route path=":emailLogId/details" element={<EmailLogDetails />} />
    </Routes>
  );
};
